import { Avatar, Box, Tooltip, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { IconQuestionMark } from '@tabler/icons-react';
import { ThemeMode } from 'config';
import React from 'react';
import useLocalization from 'hooks/useLocalization';
import { toggleGlobalAppHelpFloating, useGlobalAppHelpFloating } from 'hooks/useGlobalAppHelpFloating';

interface ContactSupportSectionProps {}

/** כפתור `?` יחיד — פותח את מגירת עוזר התמיכה (קיצורי דרך והצ'אט בתוכה) */
const ContactSupportSection: React.FC<ContactSupportSectionProps> = () => {
  const theme = useTheme();
  const { currentLocale } = useLocalization();
  const appHelp = currentLocale?.header?.appHelp;
  const { isOpen: isHelpOpen } = useGlobalAppHelpFloating();

  const handleOpenGlobalAi = () => {
    toggleGlobalAppHelpFloating();
  };

  return (
    <Box sx={{ ml: 2 }}>
      <Tooltip title={appHelp?.mainTooltip ?? 'תמיכה — עוזר AI למערכת'}>
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            border: '1px solid',
            borderColor: isHelpOpen
              ? 'primary.main'
              : theme.palette.mode === ThemeMode.DARK
                ? 'dark.main'
                : 'primary.light',
            bgcolor: isHelpOpen
              ? alpha(theme.palette.primary.main, theme.palette.mode === ThemeMode.DARK ? 0.22 : 0.14)
              : theme.palette.mode === ThemeMode.DARK
                ? 'dark.main'
                : 'primary.light',
            color: isHelpOpen ? 'primary.main' : 'primary.dark',
            boxShadow: isHelpOpen
              ? `0 0 0 2px ${alpha(theme.palette.primary.main, 0.2)}, 0 4px 14px ${alpha(theme.palette.primary.main, 0.18)}`
              : 'none',
            transition: theme.transitions.create(['background-color', 'border-color', 'color', 'box-shadow', 'transform'], {
              duration: theme.transitions.duration.shorter,
              easing: theme.transitions.easing.easeInOut,
            }),
            cursor: 'pointer',
            '&:hover': {
              borderColor: 'primary.main',
              bgcolor: isHelpOpen
                ? alpha(theme.palette.primary.main, theme.palette.mode === ThemeMode.DARK ? 0.28 : 0.18)
                : 'primary.main',
              color: isHelpOpen ? 'primary.main' : 'primary.light',
              transform: 'translateY(-1px)',
            },
          }}
          onClick={handleOpenGlobalAi}
          color="inherit"
          aria-haspopup="dialog"
          aria-expanded={isHelpOpen}
        >
          <IconQuestionMark stroke={isHelpOpen ? 2.25 : 1.75} size={20} />
        </Avatar>
      </Tooltip>
    </Box>
  );
};

export default ContactSupportSection;
